import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SiteHeader, SiteFooter } from './components/SiteChrome';
import CentrumMifre from './pages/CentrumMifre';
import LuxuryBunkers from './pages/LuxuryBunkers';
import AdminInbox from './pages/AdminInbox';
import { Globe, Building2, MapPin, Phone, Mail, ExternalLink, ChevronDown, Atom, Shield, Users, FileText, Briefcase, Handshake, Newspaper, Menu, X } from 'lucide-react';
// Logos
const SYNERGOATOM_LOGO = 'https://customer-assets.emergentagent.com/job_1aa65e8e-a75b-45c9-b8f1-5262033ce10b/artifacts/hug5mdn8_synergoatom-logo-vector.png';
const TRIUMPH_LOGO = 'https://customer-assets.emergentagent.com/job_tech-alliance-hub/artifacts/nizcij6a_triumph-sf_new_logo_full_white2.png';
const WITKOWITZ_LOGO = 'https://customer-assets.emergentagent.com/job_1aa65e8e-a75b-45c9-b8f1-5262033ce10b/artifacts/g1ldawlk_witkowitz_new_logo_white1.png';
const CESTA_LOGO = 'https://customer-assets.emergentagent.com/job_triumph-web-1/artifacts/184newnl_cesta_synergoatom_white.png';
const HERO_BG = 'https://customer-assets.emergentagent.com/job_atomic-triumph/artifacts/j4aiba58_image.png';
const API = process.env.REACT_APP_BACKEND_URL;
const translations = {
  cs: {
    lang: 'CS',
    hero: {
      subtitle: 'Evropská společnost',
      tagline: 'Systémový integrátor TRIUMPH Alliance',
      description: 'Koordinace mezinárodních projektů v oblasti energetiky, kritické infrastruktury a strategického rozvoje průmyslu'
    },
    nav: {
      about: 'O společnosti',
      activities: 'Činnost',
      cesta: 'CESTA',
      synetrium: 'SYNETRIUM',
      council: 'Koordinační rada',
      news: 'Novinky',
      alliance: 'Aliance',
      contact: 'Kontakt'
    },
    about: {
      title: 'O společnosti',
      description: 'SYNERGOATOM SE je evropská společnost založená v roce 2022 v Praze, která působí jako systémový integrátor a lídr TRIUMPH Alliance — mezinárodního strategického uskupení zaměřeného na energetiku, kritickou infrastrukturu a mezinárodní průmyslovou spolupráci.',
      role: 'Jako zakládající člen a systémová společnost Aliance koordinuje SYNERGOATOM SE strategické projekty, partnerství a integrační iniciativy mezi členy Aliance z České republiky, Ukrajiny, Lotyšska a dalších evropských zemí.',
      cesta: 'Prostřednictvím platformy CESTA SYNERGOATOM — Centra energetické stability — společnost spojuje vědecké, technologické a průmyslové podniky v oblasti jaderné energetiky a obnovitelných zdrojů.',
      legal: {
        title: 'Právní informace',
        name: 'SYNERGOATOM SE',
        type: 'Evropská společnost (Societas Europaea)',
        founded: 'Založena: 21. března 2022',
        court: 'Zapsána: H 2531/MSPH Městským soudem v Praze',
        ico: 'IČO: 14364778'
      }
    },
    activities: {
      title: 'Oblasti činnosti',
      items: [
        { icon: 'Atom', title: 'Energetika včetně jaderné', description: 'Koordinace projektů malých modulárních reaktorů (SMR), včetně technologie DAVID SMR skupiny WITKOWITZ. Spolupráce s ukrajinskými jadernými institucemi. Projekty obnovy energetické infrastruktury.' },
        { icon: 'Shield', title: 'Kritická infrastruktura', description: 'Projekty v oblasti kritické infrastruktury včetně fyzické ochrany strategických objektů a energetických zařízení.' },
        { icon: 'Briefcase', title: 'Řízení projektových konsorcií', description: 'Organizace mezinárodních vědecko-technických a výrobně-technologických projektů. Správa a koordinace projektových konsorcií.' },
        { icon: 'Handshake', title: 'Obchodní diplomacie', description: 'Meziresortní a mezivládní jednání za účelem sjednocení evropských odvětvových podniků v rámci společných programů rozvoje strategických oblastí ekonomiky.' }
      ],
      services: {
        title: 'Rozsah inženýrských a projekčních služeb',
        items: [
          'Integrované projekce a studie proveditelnosti pro jaderné a konvenční energetické projekty',
          'Inženýring a konzultace v oblasti kapitálové výstavby jaderných a klasických zařízení',
          'Provozní podpora zajišťující bezpečný, efektivní a ekonomický provoz jaderných elektráren',
          'Dokumentace posouzení vlivu na životní prostředí (EIA)',
          'Řízení stárnutí a prodloužení životnosti reaktorů typu VVER',
          'Strukturální integrita a hodnocení životnosti kritických zařízení',
          'Termohydraulické a bezpečnostní analýzy',
          'Služby hlavního projektanta: dohled a inženýrská podpora pro JE a TE'
        ]
      }
    },
    council: {
      title: 'Koordinační rada CESTA SYNERGOATOM',
      description: 'Členové Rady, opírajíce se o své zkušenosti a znalosti, jednají v zájmu realizace programů a projektů iniciovaných a řízených CESTA SYNERGOATOM.',
      members: [
        { name: 'Bronislav Kulikov', role: 'Předseda Koordinační rady', position: 'Předseda dozorčí rady Witkowitz Atomica, Zvláštní zmocněnec pro strategickou spolupráci WITKOWITZ' },
        { name: 'Anatolij Nosovskij', role: 'Místopředseda Koordinační rady', position: 'Ředitel Institutu pro problémy bezpečnosti JE NAN Ukrajiny, Akademik' },
        { name: 'Maksym Kremeň', role: 'Místopředseda Koordinační rady', position: 'Předseda Svazu veteránů atomové energetiky a průmyslu Ukrajiny' },
        { name: 'David Chrobok', role: 'Člen Koordinační rady', position: 'Předseda představenstva Witkowitz Atomica, Člen představenstva akcionářů WITKOWITZ' },
        { name: 'Dalibor Matějů', role: 'Člen Koordinační rady', position: 'Místopředseda Asociace jaderných veteránů České republiky' },
        { name: 'Jiří Žďárek', role: 'Člen Koordinační rady', position: 'Viceprezident pro rozvoj obchodu, ÚJV Řež, a. s.' },
        { name: 'Sergej Sajenko', role: 'Člen Koordinační rady', position: 'Dr. techn. věd, Vedoucí vědeckého oddělení, NSC KIPT NAN Ukrajiny' },
        { name: 'Lubov Šanina', role: 'Člen Koordinační rady', position: 'Expert Svazu veteránů atomové energetiky a průmyslu' },
        { name: 'Volodymyr Rybalčenko', role: 'Člen Koordinační rady', position: 'Ředitel Výzkumného a expertního centra jaderné energetiky, Sumská státní univerzita' },
        { name: 'Oleksandr Rjasnyj', role: 'Člen Koordinační rady', position: 'Zástupce ředitele Institutu jaderného výzkumu NAN Ukrajiny' },
        { name: 'Vladyslav Kondus', role: 'Člen Koordinační rady', position: 'Výkonný ředitel Sumského strojírenského klastru energetických zařízení, Vedoucí výzkumného oddělení Sumské státní univerzity' },
        { name: 'Robert Olejník', role: 'Člen Koordinační rady', position: 'Prezident EKOPARK S.A., partner Polské akademie věd' }
      ]
    },
    cesta: {
      title: 'CESTA-SYNERGOATOM',
      subtitle: 'Centrum energetické stability',
      description: 'Specializovaná páteřní struktura, která synergizuje mírové znalosti ATOM (jaderné), podporuje efektivní profesionální interakci mezi vědeckými, technologickými a průmyslovými podniky v oblasti jaderné energetiky.',
      mission: 'Platforma CESTA-SYNERGOATOM podporuje efektivní profesionální interakci mezi vědeckými, technologickými a průmyslovými podniky v oblasti jaderné energetiky, zejména ve spojení s obnovitelnými zdroji, buduje nové modely mezinárodní spolupráce ve strategické energetice.',
      objectives: [
        'Podporovat mezinárodní spolupráci a transfer technologií pro rozvoj mírových jaderných technologií',
        'Podporovat rozvoj jaderné vědy a energetiky jako symbolu civilizační obnovy',
        'Zajistit energetickou a ekonomickou bezpečnost evropského kontinentu',
        'Budovat nové modely mezinárodní spolupráce v oblasti strategické energetiky'
      ],
      viewDocument: 'Zobrazit dokument'
    },
    synetrium: {
      title: 'Konsorcium SYNETRIUM',
      description: 'Rámcová dohoda o konsorciu SYNETRIUM stanovuje právní a organizační rámec pro mezinárodní spolupráci v oblasti jaderné energetiky a strategických technologií.',
      viewDocument: 'Zobrazit rámcovou dohodu'
    },
    news: {
      title: 'Novinky',
      viewAll: 'Zobrazit všechny novinky',
      items: [
        { date: '2026-06-27', title: 'Partnerství ELQ / WITKOWITZ pro DAVID SMR na Ukrajině', description: 'ELQ S.A. a WITKOWITZ Group podepsaly memorandum o spolupráci na projektu DAVID SMR pro ukrajinský trh.' },
        { date: '2026-06-11', title: 'Evropský komisař navštívil člena Aliance TETERS', description: 'Valdis Dombrovskis navštívil expozici TETERS na URC 2026 a diskutoval o obnově energetické infrastruktury Ukrajiny.' },
        { date: '2026-05-29', title: 'Podpis dohody CESTA SYNERGOATOM', description: 'Významní partneři z České republiky a Ukrajiny podepsali dohodu o spolupráci v rámci platformy CESTA SYNERGOATOM.' }
      ]
    },
    alliance: {
      title: 'TRIUMPH Alliance',
      description: 'SYNERGOATOM SE je systémovou společností TRIUMPH Alliance — mezinárodního strategického uskupení, které spojuje průmyslové, vědecké a vládní partnery z České republiky, Ukrajiny a dalších evropských zemí.',
      link: 'Kompletní informace o činnosti SYNERGOATOM SE v rámci projektů Aliance naleznete na oficiálním webu:',
      cta: 'Navštívit TRIUMPH Alliance'
    },
    contact: {
      title: 'Kontakt',
      registered: 'Sídlo společnosti a provozovna',
      representative: 'Reprezentační kancelář',
      headquarters: 'Centrála WITKOWITZ Group'
    },
    footer: {
      rights: '© 2022-2026 SYNERGOATOM SE. Všechna práva vyhrazena.',
      member: 'Systémová společnost TRIUMPH Alliance'
    }
  },
  en: {
    lang: 'EN',
    hero: {
      subtitle: 'European Company',
      tagline: 'System Integrator of TRIUMPH Alliance',
      description: 'Coordination of international projects in energy, critical infrastructure and strategic industrial development'
    },
    nav: {
      about: 'About',
      activities: 'Activities',
      cesta: 'CESTA',
      synetrium: 'SYNETRIUM',
      council: 'Coordination Council',
      news: 'News',
      alliance: 'Alliance',
      contact: 'Contact'
    },
    about: {
      title: 'About the Company',
      description: 'SYNERGOATOM SE is a European company founded in 2022 in Prague, operating as a system integrator and leader of TRIUMPH Alliance — an international strategic grouping focused on energy, critical infrastructure and international industrial cooperation.',
      role: 'As a founding member and system company of the Alliance, SYNERGOATOM SE coordinates strategic projects, partnerships and integration initiatives among Alliance members from the Czech Republic, Ukraine, Latvia and other European countries.',
      cesta: 'Through the CESTA SYNERGOATOM platform — the Center for Energy Stability — the company unites scientific, technological, and industrial enterprises in the field of nuclear energy and renewable sources.',
      legal: {
        title: 'Legal Information',
        name: 'SYNERGOATOM SE',
        type: 'European Company (Societas Europaea)',
        founded: 'Founded: March 21, 2022',
        court: 'Registered: H 2531/MSPH at Prague Municipal Court',
        ico: 'Company ID: 14364778'
      }
    },
    activities: {
      title: 'Areas of Activity',
      items: [
        { icon: 'Atom', title: 'Energy Including Nuclear', description: "Coordination of small modular reactor (SMR) projects, including WITKOWITZ Group's DAVID SMR technology. Cooperation with Ukrainian nuclear institutions. Energy infrastructure recovery projects." },
        { icon: 'Shield', title: 'Critical Infrastructure', description: 'Projects in the field of critical infrastructure including physical protection of strategic facilities and energy installations.' },
        { icon: 'Briefcase', title: 'Project Consortium Management', description: 'Organization of international scientific-technical and production-technological projects. Management and coordination of project consortia.' },
        { icon: 'Handshake', title: 'Business Diplomacy', description: 'Interdepartmental and intergovernmental negotiations for uniting European industry enterprises within joint programs for developing strategic economic sectors.' }
      ],
      services: {
        title: 'Scope of Engineering and Design Services',
        items: [
          'Integrated design and feasibility studies for nuclear and conventional energy projects',
          'Engineering and consulting in capital construction for nuclear and classical facilities',
          'Operational support ensuring safe, efficient, and economic performance of nuclear plants',
          'Environmental Impact Assessment (EIA) documentation',
          'Aging management and lifetime extension of VVER-type reactors',
          'Structural integrity and lifetime assessment of critical equipment',
          'Thermo-hydraulic and safety analyses',
          'Chief Designer services: supervision and engineering support for NPPs and TPPs'
        ]
      }
    },
    council: {
      title: 'CESTA SYNERGOATOM Coordinating Council',
      description: 'Council members, relying on their experience and knowledge, act in the interests of the implementation of programs and projects initiated and managed by CESTA SYNERGOATOM.',
      members: [
        { name: 'Bronislav Kulikov', role: 'Chairman of the Coordinating Council', position: 'Chairman of Supervisory Board Witkowitz Atomica, Special Envoy for Strategic Cooperation WITKOWITZ' },
        { name: 'Anatolii Nosovskiy', role: 'Vice-Chairman of the Coordinating Council', position: 'Director of the Institute for Safety Problems of NPPs, National Academy of Sciences of Ukraine, Academician' },
        { name: 'Maksym Kremen', role: 'Vice-Chairman of the Coordinating Council', position: 'Head of Ukrainian Union of Veterans of Atomic Energy and Industry' },
        { name: 'David Chrobok', role: 'Member of the Coordinating Council', position: 'Chairman of the Board Witkowitz Atomica, Member of the Shareholders Board WITKOWITZ' },
        { name: 'Dalibor Matějů', role: 'Member of the Coordinating Council', position: 'Vice-president of the Association of Nuclear Veterans of the Czech Republic' },
        { name: 'Jiří Žďárek', role: 'Member of the Coordinating Council', position: 'Vice-president for Business Development, ÚJV Řež, a. s.' },
        { name: 'Sergey Sayenko', role: 'Member of the Coordinating Council', position: 'Dr. Techn. Sciences, Head of Scientific Department, NSC KIPT of NAS of Ukraine' },
        { name: 'Lubov Shanina', role: 'Member of the Coordinating Council', position: 'Expert of the Union of Veterans of Atomic Energy and Industry' },
        { name: 'Volodymyr Rybalchenko', role: 'Member of the Coordinating Council', position: 'Director of Research and Expert Center for Nuclear and Power Engineering, Sumy State University' },
        { name: 'Oleksandr Riasnyi', role: 'Member of the Coordinating Council', position: 'Deputy Director of the Institute for Nuclear Research, NAS of Ukraine' },
        { name: 'Vladyslav Kondus', role: 'Member of the Coordinating Council', position: 'Executive Director, Sumy Machine-Building Cluster of Energy Equipment, Head of Research Division, Sumy State University' },
        { name: 'Robert Olejnik', role: 'Member of the Coordinating Council', position: 'President EKOPARK S.A., partner of the Polish Academy of Sciences' }
      ]
    },
    cesta: {
      title: 'CESTA-SYNERGOATOM',
      subtitle: 'Center for Energy Stability',
      description: 'A specialized backbone structure that synergizes peaceful ATOM (nuclear) knowledge, fostering effective professional interaction between scientific, technological, and industrial enterprises in the field of nuclear energy.',
      mission: 'CESTA-SYNERGOATOM fosters effective professional interaction between scientific, technological, and industrial enterprises in the field of nuclear energy, particularly in conjunction with renewable sources, building new models of international cooperation in strategic energy.',
      objectives: [
        'Foster international collaboration and technology transfer for advancement of peaceful nuclear technologies',
        'Promote development of nuclear science and energy as a symbol of civilizational renewal',
        'Ensure energy and economic security of the European continent',
        'Build new models of international cooperation in the field of strategic energy'
      ],
      viewDocument: 'View Document'
    },
    synetrium: {
      title: 'SYNETRIUM Consortium',
      description: 'The SYNETRIUM Consortium Framework Agreement establishes the legal and organizational framework for international cooperation in nuclear energy and strategic technologies.',
      viewDocument: 'View Framework Agreement'
    },
    news: {
      title: 'News',
      viewAll: 'View all news',
      items: [
        { date: '2026-06-27', title: 'ELQ / WITKOWITZ Partnership for DAVID SMR in Ukraine', description: 'ELQ S.A. and WITKOWITZ Group signed a memorandum of cooperation on the DAVID SMR project for the Ukrainian market.' },
        { date: '2026-06-11', title: 'European Commissioner Visits Alliance Member TETERS', description: "Valdis Dombrovskis visited the TETERS exhibition at URC 2026 and discussed rebuilding Ukraine's energy infrastructure." },
        { date: '2026-05-29', title: 'CESTA SYNERGOATOM Agreement Signed', description: 'Key partners from the Czech Republic and Ukraine signed a cooperation agreement within the CESTA SYNERGOATOM platform.' }
      ]
    },
    alliance: {
      title: 'TRIUMPH Alliance',
      description: 'SYNERGOATOM SE is the system company of TRIUMPH Alliance — an international strategic grouping that unites industrial, scientific and governmental partners from the Czech Republic, Ukraine and other European countries.',
      link: 'Complete information about SYNERGOATOM SE activities within Alliance projects can be found on the official website:',
      cta: 'Visit TRIUMPH Alliance'
    },
    contact: {
      title: 'Contact',
      registered: 'Registered Office & Operations',
      representative: 'Representative Office',
      headquarters: 'WITKOWITZ Group Headquarters'
    },
    footer: {
      rights: '© 2022-2026 SYNERGOATOM SE. All rights reserved.',
      member: 'System Company of TRIUMPH Alliance'
    }
  }
};
const IconComponent = ({ name, className }) => {
  const icons = { Atom, Shield, Briefcase, Handshake };
  const Icon = icons[name];
  return Icon ? <Icon className={className} /> : null;
};
const CONTACT_FORM_T = {
  cs: { title: 'Napište nám', desc: 'Vyplňte formulář a naši pracovníci se vám ozvou.', name: 'Jméno', org: 'Organizace (nepovinné)', email: 'E-mail', phone: 'Telefon (nepovinné)', subject: 'Předmět (nepovinné)', message: 'Zpráva', send: 'Odeslat zprávu', sending: 'Odesílání…', success: 'Děkujeme. Vaše zpráva byla odeslána.', error: 'Odeslání se nezdařilo. Zkuste to prosím znovu.' },
  en: { title: 'Write to us', desc: 'Send us a message and our team will get back to you.', name: 'Name', org: 'Organization (optional)', email: 'Email', phone: 'Phone (optional)', subject: 'Subject (optional)', message: 'Message', send: 'Send message', sending: 'Sending…', success: 'Thank you. Your message has been sent.', error: 'Submission failed. Please try again.' },
};

function ContactForm({ lang }) {
  const t = CONTACT_FORM_T[lang] || CONTACT_FORM_T.en;
  const [form, setForm] = useState({ name: '', organization: '', email: '', phone: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle');
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(`${API}/api/contact`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error('bad');
      setStatus('done');
      setForm({ name: '', organization: '', email: '', phone: '', subject: '', message: '' });
    } catch { setStatus('error'); }
  };

  if (status === 'done') {
    return (
      <div className="mt-8 bg-slate-800/50 border border-slate-700 rounded-2xl p-8 text-center" data-testid="contact-form-success">
        <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#D4A84B22' }}>
          <Mail className="w-6 h-6 text-[#D4A84B]" />
        </div>
        <p className="text-white text-lg">{t.success}</p>
        <a href="mailto:office@synergoatom.com" className="text-[#D4A84B] hover:underline text-sm mt-2 inline-block">office@synergoatom.com</a>
      </div>
    );
  }

  const inputCls = 'w-full bg-slate-900 border border-slate-700 rounded-lg p-3 text-white focus:border-[#D4A84B] outline-none';
  return (
    <form onSubmit={submit} className="mt-8 bg-slate-800/50 border border-slate-700 rounded-2xl p-6 sm:p-8" data-testid="contact-form">
      <h3 className="text-xl font-semibold text-[#D4A84B] mb-1 flex items-center gap-2"><Mail className="w-5 h-5" />{t.title}</h3>
      <p className="text-sm text-slate-400 mb-6">{t.desc}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <input data-testid="contact-name" required placeholder={t.name} value={form.name} onChange={(e) => set('name', e.target.value)} className={inputCls} />
        <input data-testid="contact-org" placeholder={t.org} value={form.organization} onChange={(e) => set('organization', e.target.value)} className={inputCls} />
        <input data-testid="contact-email" required type="email" placeholder={t.email} value={form.email} onChange={(e) => set('email', e.target.value)} className={inputCls} />
        <input data-testid="contact-phone" placeholder={t.phone} value={form.phone} onChange={(e) => set('phone', e.target.value)} className={inputCls} />
        <input data-testid="contact-subject" placeholder={t.subject} value={form.subject} onChange={(e) => set('subject', e.target.value)} className={`${inputCls} sm:col-span-2`} />
        <textarea data-testid="contact-message" required rows={5} placeholder={t.message} value={form.message} onChange={(e) => set('message', e.target.value)} className={`${inputCls} sm:col-span-2`} />
      </div>
      {status === 'error' && <p data-testid="contact-form-error" className="text-sm text-red-400 mt-4">{t.error}</p>}
      <button data-testid="contact-submit" type="submit" disabled={status === 'sending'}
        className="mt-6 inline-flex items-center gap-2 px-8 py-3 bg-[#D4A84B] text-slate-900 font-semibold rounded-lg hover:bg-[#c49a3f] transition-colors disabled:opacity-50">
        {status === 'sending' ? t.sending : t.send}
      </button>
    </form>
  );
}

function HomePage({ lang, setLang }) {
  const [pdfModal, setPdfModal] = useState({ open: false, url: '', title: '' });
  const location = useLocation();
  const t = translations[lang];
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [lang]);
  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const id = location.state.scrollTo;
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
    }
  }, [location]);
  const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  const openPdfModal = (url, title) => setPdfModal({ open: true, url, title });
  const closePdfModal = () => setPdfModal({ open: false, url: '', title: '' });
  return (
    <div className="min-h-screen bg-slate-900 text-white font-['Space_Grotesk',sans-serif]" data-testid="synergoatom-app">
      {/* PDF Modal */}
      {pdfModal.open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-testid="pdf-modal">
          <div className="relative w-full max-w-5xl h-[90vh] bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden flex flex-col">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-700 bg-slate-800">
              <h3 className="text-lg font-semibold text-white">{pdfModal.title}</h3>
              <button onClick={closePdfModal} data-testid="pdf-modal-close" className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-700 hover:bg-slate-600 transition-colors text-white">✕</button>
            </div>
            <div className="flex-1 bg-slate-200">
              <iframe src={`https://docs.google.com/viewer?url=${encodeURIComponent(pdfModal.url)}&embedded=true`} className="w-full h-full border-0" title={pdfModal.title} />
            </div>
          </div>
        </div>
      )}
      {/* Header */}
      <SiteHeader lang={lang} setLang={setLang} />
      {/* Hero */}
      <section className="relative min-h-screen flex items-center justify-center pt-20" style={{ backgroundImage: `linear-gradient(to bottom, rgba(15,23,42,0.7), rgba(15,23,42,0.9)), url(${HERO_BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#D4A84B] uppercase tracking-widest text-sm mb-4">{t.hero.subtitle}</p>
          <img src={SYNERGOATOM_LOGO} alt="SYNERGOATOM SE" className="w-full max-w-[260px] sm:max-w-lg lg:max-w-2xl h-auto mx-auto mb-6 object-contain" />
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 font-['Syne',sans-serif]">{t.hero.tagline}</h1>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-10">{t.hero.description}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={() => scrollToSection('about')} data-testid="hero-about-button" className="px-8 py-3 bg-[#D4A84B] text-slate-900 font-semibold rounded-lg hover:bg-[#c49a3f] transition-colors">{t.nav.about}</button>
            <a href="https://triumph-alliance.com" target="_blank" rel="noopener noreferrer" data-testid="hero-alliance-link" className="px-8 py-3 border border-[#D4A84B] text-[#D4A84B] font-semibold rounded-lg hover:bg-[#D4A84B]/10 transition-colors flex items-center justify-center gap-2">TRIUMPH Alliance<ExternalLink className="w-4 h-4" /></a>
          </div>
        </div>
      </section>
      {/* About */}
      <section id="about" className="py-16 sm:py-20 bg-slate-900 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8 font-['Syne',sans-serif] text-center">{t.about.title}</h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <p className="text-gray-300 text-lg mb-6 leading-relaxed">
                SYNERGOATOM SE {lang === 'cs' ? 'je evropská společnost založená v roce 2022 v Praze, která působí jako systémový integrátor a lídr' : 'is a European company founded in 2022 in Prague, operating as a system integrator and leader of'}{' '}
                <a href="https://triumph-alliance.com/" target="_blank" rel="noopener noreferrer" className="text-[#D4A84B] hover:underline">TRIUMPH Alliance</a>
                {' — '}{lang === 'cs' ? 'mezinárodního strategického uskupení zaměřeného na energetiku, kritickou infrastrukturu a mezinárodní průmyslovou spolupráci.' : 'an international strategic grouping focused on energy, critical infrastructure and international industrial cooperation.'}
              </p>
              <p className="text-gray-300 text-lg mb-6 leading-relaxed">{t.about.role}</p>
              <p className="text-gray-300 text-lg leading-relaxed">
                {lang === 'cs' ? 'Prostřednictvím platformy' : 'Through the'}{' '}
                <a href="https://triumph-alliance.com/platforms/cesta-synergoatom" target="_blank" rel="noopener noreferrer" className="text-[#D4A84B] hover:underline">CESTA SYNERGOATOM</a>
                {' — '}{lang === 'cs' ? 'Centra energetické stability — společnost spojuje vědecké, technologické a průmyslové podniky v oblasti jaderné energetiky a obnovitelných zdrojů.' : 'the Center for Energy Stability — the company unites scientific, technological, and industrial enterprises in the field of nuclear energy and renewable sources.'}
              </p>
            </div>
            <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8">
              <h3 className="text-xl font-semibold text-[#D4A84B] mb-6 flex items-center gap-3"><FileText className="w-5 h-5" />{t.about.legal.title}</h3>
              <div className="space-y-4 text-gray-300">
                <p className="font-semibold text-white text-lg">{t.about.legal.name}</p>
                <p>{t.about.legal.type}</p>
                <p>{t.about.legal.founded}</p>
                <p>{t.about.legal.court}</p>
                <p className="font-mono text-[#D4A84B]">{t.about.legal.ico}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Activities */}
      <section id="activities" className="py-16 sm:py-20 bg-slate-800/30 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-12 font-['Syne',sans-serif] text-center">{t.activities.title}</h2>
          <div className="grid sm:grid-cols-2 gap-6 mb-12">
            {t.activities.items.map((item, index) => (
              <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 hover:border-[#D4A84B]/50 transition-colors">
                <div className="w-12 h-12 bg-[#D4A84B]/10 rounded-xl flex items-center justify-center mb-4">
                  <IconComponent name={item.icon} className="w-6 h-6 text-[#D4A84B]" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{item.title}</h3>
                <p className="text-gray-400 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
          {t.activities.services && (
            <div className="bg-slate-900/50 border border-slate-700 rounded-2xl p-8">
              <h3 className="text-xl font-semibold text-[#D4A84B] mb-6">{t.activities.services.title}</h3>
              <ul className="grid md:grid-cols-2 gap-3">
                {t.activities.services.items.map((item, index) => (
                  <li key={index} className="flex items-start gap-3 text-gray-300"><span className="text-[#D4A84B] mt-1">•</span><span>{item}</span></li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>
      {/* CESTA */}
      <section id="cesta" className="py-16 sm:py-20 bg-slate-900 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-4 mb-6">
            <img src={CESTA_LOGO} alt="CESTA SYNERGOATOM" className="h-12 sm:h-16 w-auto" />
          </div>
          <p className="text-[#D4A84B] text-center uppercase tracking-widest text-sm mb-4">{t.cesta.subtitle}</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8 font-['Syne',sans-serif] text-center">{t.cesta.title}</h2>
          <p className="text-gray-300 text-lg text-center max-w-3xl mx-auto mb-8">{t.cesta.description}</p>
          <p className="text-gray-400 text-center max-w-3xl mx-auto mb-10">{t.cesta.mission}</p>
          <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8 mb-8">
            <ul className="grid md:grid-cols-2 gap-4">
              {t.cesta.objectives.map((objective, index) => (
                <li key={index} className="flex items-start gap-3 text-gray-300"><span className="text-[#D4A84B] mt-1 flex-shrink-0">✓</span><span>{objective}</span></li>
              ))}
            </ul>
          </div>
          <div className="text-center">
            <button onClick={() => openPdfModal('https://customer-assets.emergentagent.com/job_1aa65e8e-a75b-45c9-b8f1-5262033ce10b/artifacts/nftfyr5f_CESTA%20SYNERGOATOM%20SIGN.pdf', 'CESTA SYNERGOATOM')} data-testid="cesta-view-doc" className="inline-flex items-center gap-3 px-8 py-4 bg-[#D4A84B] text-slate-900 font-semibold rounded-lg hover:bg-[#c49a3f] transition-colors">
              <FileText className="w-5 h-5" />{t.cesta.viewDocument}
            </button>
          </div>
        </div>
      </section>
      {/* SYNETRIUM */}
      <section id="synetrium" className="py-16 sm:py-20 bg-slate-800/30 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6 font-['Syne',sans-serif]">{t.synetrium.title}</h2>
          <p className="text-gray-300 text-lg max-w-3xl mx-auto mb-10">{t.synetrium.description}</p>
          <button onClick={() => openPdfModal('https://customer-assets.emergentagent.com/job_1aa65e8e-a75b-45c9-b8f1-5262033ce10b/artifacts/rcpc9qoh_03_SYNETRIUM_Consortium_Framework_Agreement.pdf', 'SYNETRIUM Consortium Framework Agreement')} data-testid="synetrium-view-doc" className="inline-flex items-center gap-3 px-8 py-4 border-2 border-[#D4A84B] text-[#D4A84B] font-semibold rounded-lg hover:bg-[#D4A84B]/10 transition-colors">
            <FileText className="w-5 h-5" />{t.synetrium.viewDocument}
          </button>
        </div>
      </section>
      {/* Council */}
      <section id="council" className="py-16 sm:py-20 bg-slate-900 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6 font-['Syne',sans-serif] text-center">{t.council.title}</h2>
          <p className="text-gray-400 text-center max-w-3xl mx-auto mb-12">{t.council.description}</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {t.council.members.map((member, index) => (
              <div key={index} className={`bg-slate-800/50 border rounded-xl p-5 ${index < 3 ? 'border-[#D4A84B]/50' : 'border-slate-700'}`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${index < 3 ? 'bg-[#D4A84B]/20' : 'bg-slate-700'}`}>
                    <Users className={`w-5 h-5 ${index < 3 ? 'text-[#D4A84B]' : 'text-gray-400'}`} />
                  </div>
                  <div>
                    <p className="font-semibold text-white">{member.name}</p>
                    <p className={`text-xs ${index < 3 ? 'text-[#D4A84B]' : 'text-gray-500'}`}>{member.role}</p>
                  </div>
                </div>
                <p className="text-sm text-gray-400 leading-relaxed">{member.position}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* News */}
      <section id="news" className="py-16 sm:py-20 bg-slate-800/30 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center gap-3 mb-8">
            <Newspaper className="w-8 h-8 text-[#D4A84B]" />
            <h2 className="text-3xl sm:text-4xl font-bold text-white font-['Syne',sans-serif]">{t.news.title}</h2>
          </div>
          <div className="space-y-4 mb-10">
            {t.news.items.map((item, index) => (
              <div key={index} className="bg-slate-900/50 border border-slate-700 rounded-xl p-6 hover:border-[#D4A84B]/30 transition-colors">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 bg-[#D4A84B]/10 rounded-lg px-3 py-2 text-center min-w-[70px]">
                    <p className="text-[#D4A84B] font-semibold text-sm">{new Date(item.date).toLocaleDateString(lang === 'cs' ? 'cs-CZ' : 'en-US', { month: 'short' })}</p>
                    <p className="text-white text-xl font-bold">{new Date(item.date).getDate()}</p>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center">
            <a href="https://triumph-alliance.com/news" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#D4A84B] hover:underline font-medium">{t.news.viewAll}<ExternalLink className="w-4 h-4" /></a>
          </div>
        </div>
      </section>
      {/* Alliance */}
      <section id="alliance" className="py-16 sm:py-20 bg-slate-900 reveal">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8 font-['Syne',sans-serif]">{t.alliance.title}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-3xl mx-auto">{t.alliance.description}</p>
          <div className="flex flex-wrap justify-center items-center gap-8 mb-10 opacity-70">
            <img src={TRIUMPH_LOGO} alt="TRIUMPH Alliance" className="h-10 w-auto" />
            <img src={WITKOWITZ_LOGO} alt="WITKOWITZ Group" className="h-8 w-auto" />
            <img src={CESTA_LOGO} alt="CESTA SYNERGOATOM" className="h-10 w-auto" />
          </div>
          <p className="text-gray-400 mb-6">{t.alliance.link}</p>
          <a href="https://triumph-alliance.com" target="_blank" rel="noopener noreferrer" data-testid="alliance-cta" className="inline-flex items-center gap-3 px-8 py-4 bg-[#D4A84B] text-slate-900 font-semibold rounded-lg hover:bg-[#c49a3f] transition-colors text-lg">{t.alliance.cta}<ExternalLink className="w-5 h-5" /></a>
        </div>
      </section>
      {/* Contact */}
      <section id="contact" className="py-16 sm:py-20 bg-slate-800/30 reveal">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-12 font-['Syne',sans-serif] text-center">{t.contact.title}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6">
              <h3 className="text-lg font-semibold text-[#D4A84B] mb-4 flex items-center gap-2"><Building2 className="w-5 h-5" />{t.contact.registered}</h3>
              <div className="space-y-3 text-gray-300">
                <p className="flex items-start gap-3"><MapPin className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" /><span>Husitská 232/59<br />130 00 Praha 3-Žižkov<br />Czech Republic</span></p>
                <p className="flex items-center gap-3"><Phone className="w-5 h-5 text-gray-500" /><a href="tel:+420776157777" className="hover:text-[#D4A84B] transition-colors">+420 776 157 777</a></p>
                <p className="flex items-center gap-3"><Mail className="w-5 h-5 text-gray-500" /><a href="mailto:office@synergoatom.com" className="hover:text-[#D4A84B] transition-colors">office@synergoatom.com</a></p>
              </div>
            </div>
            <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6">
              <h3 className="text-lg font-semibold text-[#D4A84B] mb-4 flex items-center gap-2"><Building2 className="w-5 h-5" />{t.contact.representative}</h3>
              <p className="text-xs text-gray-500 mb-3">{t.contact.headquarters}</p>
              <div className="space-y-3 text-gray-300">
                <p className="flex items-start gap-3"><MapPin className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" /><span>Václavské náměstí 772/2<br />110 00 Praha 1<br />Czech Republic</span></p>
              </div>
            </div>
          </div>
          <ContactForm lang={lang} />
        </div>
      </section>
      {/* Footer */}
      <SiteFooter lang={lang} />
    </div>
  );
}

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (!location.state || !location.state.scrollTo) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location.pathname]);
  return null;
}

export default function App() {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('synergoatom_lang') || 'cs'; } catch (e) { return 'cs'; }
  });
  useEffect(() => {
    try { localStorage.setItem('synergoatom_lang', lang); } catch (e) { /* ignore */ }
  }, [lang]);
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage lang={lang} setLang={setLang} />} />
        <Route path="/synergomodule" element={<CentrumMifre lang={lang} setLang={setLang} />} />
        <Route path="/luxury-bunkers" element={<LuxuryBunkers lang={lang} setLang={setLang} />} />
        <Route path="/admin" element={<AdminInbox />} />
      </Routes>
    </BrowserRouter>
  );
}
